export default {
	SetFeatureFlags(state, flags) {
		state.featureFlags = flags
	},
	SetFeatureFlag(state, flag) {
		const currentFlags = state.featureFlags

		state.featureFlags = [...currentFlags, flag]
	},
}
